// extracted by mini-css-extract-plugin
export default {"container":"ItemAttributeForm_container__ZE5G8"};